import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import spartaSqueezeboxUtility from '@sparta.global.utilities/sparta-squeezebox-utility/dist/es6.js';
import spartaUILayersUtility from '@sparta.global.utilities/sparta-ui-layers-utility/dist/es6.js';
import spartaValidationFramework from '@sparta.global.utilities/sparta-validation-framework-utility/dist/es6.js';
import $ from '@sparta.global.vendors/jquery';
import CommonAutoUtility from '@sparta.auto-loans.utilities/common-auto-utility/dist/es6.js';
import CommonUtility from '@sparta.sales.utilities/common-utility/dist/es6.js';
import RatesUtility from '@sparta.sales.utilities/rates-utility/dist/es6.js';
import '@sparta.global.utilities/sparta-input-error-utility/dist/es6.js';
import { squeezebox } from '@sparta.global.helpers/squeezebox-helper/dist/es6.js';
import { interestRateInput, currencyInput } from '@sparta.global.helpers/text-inputs-helper/dist/es6.js';
import { link } from '@sparta.global.helpers/sparta-helper/dist/es6.js';

const Handlebars = require('@sparta.global.vendors/handlebars');
const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <div class=\"row\">\n    <h2 class=\"header\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"header") || (depth0 != null ? lookupProperty(depth0,"header") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"header","hash":{},"data":data,"loc":{"start":{"line":7,"column":23},"end":{"line":7,"column":35}}}) : helper))) != null ? stack1 : "")
    + "</h2>\n    <p class=\"heading\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"headerText") || (depth0 != null ? lookupProperty(depth0,"headerText") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"headerText","hash":{},"data":data,"loc":{"start":{"line":8,"column":23},"end":{"line":8,"column":39}}}) : helper))) != null ? stack1 : "")
    + "</p>\n  </div>\n\n  <div class=\"row\">\n    <div class=\"large-5 medium-6 column\">\n      <form id=\"globalInputsValidationForm\" data-parsley-validate>\n        <div class=\"row\">\n          <div data-defaultLoanAmt= "
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"totalLoanAmount") : depth0)) != null ? lookupProperty(stack1,"input") : stack1)) != null ? lookupProperty(stack1,"defaultLoanAmt") : stack1), depth0))
    + " class=\"small-10 medium-12 large-12\n              small-centered column no-pad\n          \">\n            "
    + container.escapeExpression((lookupProperty(helpers,"currencyInput")||(depth0 && lookupProperty(depth0,"currencyInput"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"totalLoanAmount") : depth0),{"name":"currencyInput","hash":{},"data":data,"loc":{"start":{"line":18,"column":12},"end":{"line":18,"column":45}}}))
    + "\n          </div>\n\n          <div class=\"squeezebox-wrapper\" id=\"tabsetExample\" data-squeezebox-type=\"accordion\">\n\n            <div class=\"squeezebox-panels\">\n              <!-- Config tab -->\n              <div class=\"squeezebox-panel\" id=\"calculatorPanel\">\n                <a href=\"javascript:void(0)\" class=\"panel-header spa-oline transparent\" data-panel=\"calculatorPanel\" role=\"link\">\n            <span class=\"spa-squeezebox-arrow spa-icon spa-arrow-btn--learn-more\"></span>\n            "
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"breakDownLink") : depth0), depth0)) != null ? stack1 : "")
    + "\n            <span class=\"ada-hidden\"></span>\n            <span class=\"panel-status-icon error\" data-label=\"contains an error message\"></span>\n            <span class=\"panel-status-icon warning\" data-label=\"contains a warning message\"></span>\n            <span class=\"panel-status-icon success\" data-label=\"contains a success message\"></span>\n          </a>\n                <div class=\"panel-content\" aria-labelledby=\"tabsetExampleTab1\">\n                  <div class=\"content\">\n                    <div class=\"row\">\n                      <div class=\"column\">\n                        <div id=\"panel1\" class=\"spa-squeezebox-content\">\n                          <div class=\"break-down\">\n                            <div class=\"inputs-break-down\">\n                              <div class=\"row\">\n                                <div class=\"small-8 medium-8 large-8 small-centered column\">\n                                  "
    + ((stack1 = (lookupProperty(helpers,"currencyInput")||(depth0 && lookupProperty(depth0,"currencyInput"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"carPrice") : depth0),{"name":"currencyInput","hash":{},"data":data,"loc":{"start":{"line":43,"column":34},"end":{"line":43,"column":62}}})) != null ? stack1 : "")
    + "\n                                </div>\n                              </div>\n                              <div class=\"row\">\n                                <div class=\"small-8 medium-8 large-8 small-centered column\">\n                                  "
    + ((stack1 = (lookupProperty(helpers,"currencyInput")||(depth0 && lookupProperty(depth0,"currencyInput"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"tradeInValue") : depth0),{"name":"currencyInput","hash":{},"data":data,"loc":{"start":{"line":48,"column":34},"end":{"line":48,"column":66}}})) != null ? stack1 : "")
    + "\n                                </div>\n                              </div>\n                              <div class=\"row\">\n                                <div class=\"small-8 medium-8 large-8 small-centered column\">\n                                  "
    + ((stack1 = (lookupProperty(helpers,"currencyInput")||(depth0 && lookupProperty(depth0,"currencyInput"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"amtOwedTradeIn") : depth0),{"name":"currencyInput","hash":{},"data":data,"loc":{"start":{"line":53,"column":34},"end":{"line":53,"column":68}}})) != null ? stack1 : "")
    + "\n                                </div>\n                              </div>\n                              <div class=\"row\">\n                                <div class=\"small-8 medium-8 large-8 small-centered column\">\n                                  "
    + ((stack1 = (lookupProperty(helpers,"currencyInput")||(depth0 && lookupProperty(depth0,"currencyInput"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"downPayment") : depth0),{"name":"currencyInput","hash":{},"data":data,"loc":{"start":{"line":58,"column":34},"end":{"line":58,"column":65}}})) != null ? stack1 : "")
    + "\n                                </div>\n                              </div>\n                              <div class=\"row\">\n                                <div class=\"small-8 medium-8 large-8 small-centered column\">\n                                  "
    + ((stack1 = (lookupProperty(helpers,"currencyInput")||(depth0 && lookupProperty(depth0,"currencyInput"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"cashRebate") : depth0),{"name":"currencyInput","hash":{},"data":data,"loc":{"start":{"line":63,"column":34},"end":{"line":63,"column":64}}})) != null ? stack1 : "")
    + "\n                                </div>\n                              </div>\n                            </div>\n                            <div class=\"row update\">\n                              <div class=\"small-10 medium-10 large-10\">\n                                "
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"updateTotal") : depth0),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":69,"column":32},"end":{"line":69,"column":54}}})) != null ? stack1 : "")
    + "\n                              </div>\n                            </div>\n                          </div>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"row\">\n          <div class=\"small-10 medium-12 large-12 small-centered column no-pad\">\n            "
    + ((stack1 = (lookupProperty(helpers,"currencyInput")||(depth0 && lookupProperty(depth0,"currencyInput"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"term") : depth0),{"name":"currencyInput","hash":{},"data":data,"loc":{"start":{"line":85,"column":12},"end":{"line":85,"column":36}}})) != null ? stack1 : "")
    + "\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"small-10 medium-12 large-12 small-centered column no-pad interest-rate\">\n            "
    + ((stack1 = (lookupProperty(helpers,"interestRateInput")||(depth0 && lookupProperty(depth0,"interestRateInput"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"interestRate") : depth0),{"name":"interestRateInput","hash":{},"data":data,"loc":{"start":{"line":90,"column":12},"end":{"line":90,"column":48}}})) != null ? stack1 : "")
    + "\n          </div>\n          <div class=\"small-10 medium-12 large-12 small-centered column no-pad interest-rate-iphone hide\">\n            "
    + ((stack1 = (lookupProperty(helpers,"interestRateInput")||(depth0 && lookupProperty(depth0,"interestRateInput"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"interestRateIphone") : depth0),{"name":"interestRateInput","hash":{},"data":data,"loc":{"start":{"line":93,"column":12},"end":{"line":93,"column":54}}})) != null ? stack1 : "")
    + "\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"small-10 medium-12 large-12 small-centered column no-pad link-box\" data-font=\"cnx-regular\">\n            "
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"LINKS") : depth0)) != null ? lookupProperty(stack1,"currentRates") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":98,"column":12},"end":{"line":98,"column":41}}})) != null ? stack1 : "")
    + "\n          </div>\n        </div>\n        <div class=\"row\">\n          "
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"calculateButton") : depth0),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":102,"column":10},"end":{"line":102,"column":36}}})) != null ? stack1 : "")
    + "\n        </div>\n        <div class=\"row calculate-text\">\n          <p>"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"calculateText") || (depth0 != null ? lookupProperty(depth0,"calculateText") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"calculateText","hash":{},"data":data,"loc":{"start":{"line":105,"column":13},"end":{"line":105,"column":32}}}) : helper))) != null ? stack1 : "")
    + "</p>\n        </div>\n\n      </form>\n    </div>\n\n    <div class=\"large-5 medium-6 small-12 column\">\n      <div class=\"results\">\n        <div class=\"apply-heading hide-for-small-only\">\n          "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"apply") : depth0)) != null ? lookupProperty(stack1,"heading") : stack1), depth0)) != null ? stack1 : "")
    + "\n        </div>\n        <div class=\"apply-heading show-for-small-only\">\n          "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"apply") : depth0)) != null ? lookupProperty(stack1,"headingSmall") : stack1), depth0)) != null ? stack1 : "")
    + "\n        </div>\n        <div class=\"payment\">\n          <span class=\"dollar\">&#36;</span><span class=\"TL_NPI_L1\" id=\"amount\"></span>\n        </div>\n        <div class=\"amount-text\">\n          "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"apply") : depth0)) != null ? lookupProperty(stack1,"loanAmount") : stack1), depth0)) != null ? stack1 : "")
    + "\n        </div>\n        <div class=\"apply small-9 medium-10 small-centered column\">\n          "
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"apply") : depth0)) != null ? lookupProperty(stack1,"applyButton") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":126,"column":10},"end":{"line":126,"column":38}}})) != null ? stack1 : "")
    + " </div>\n        <div class=\"eligibility-link\">\n          "
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"apply") : depth0)) != null ? lookupProperty(stack1,"eligibility") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":128,"column":10},"end":{"line":128,"column":40}}})) != null ? stack1 : "")
    + "\n        </div>\n      </div>\n    </div>\n\n  </div>\n\n  <div class=\"row\">\n    <div class=\"small-12 small-centered column\">\n      <div class=\"squeezebox-container\">\n        "
    + container.escapeExpression((lookupProperty(helpers,"squeezebox")||(depth0 && lookupProperty(depth0,"squeezebox"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"partials") : depth0),(depth0 != null ? lookupProperty(depth0,"disclosure") : depth0),{"name":"squeezebox","hash":{},"data":data,"loc":{"start":{"line":138,"column":8},"end":{"line":138,"column":47}}}))
    + "\n      </div>\n    </div>\n  </div>\n\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"data1") : depth0),{"name":"with","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":0},"end":{"line":143,"column":9}}})) != null ? stack1 : "");
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.auto-loans.modules/payment-calc-auto-module",
  "version": "2.0.0",
  "id": "paymentCalcAutoModuleJS",
  "containerID": "autoLoansPaymentCalcAutoModule",
  "moduleName": "auto-loans-payment-calc-auto-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "payment-calc-auto-module",
  "data": {
    "init": "paymentCalcAutoModuleJS"
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        squeezebox,
        interestRateInput,
        currencyInput,
        link
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    squeezebox,
    interestRateInput,
    currencyInput,
    link
  },
  "dependencies": {
    "@sparta.auto-loans.utilities/common-auto-utility": "^1.0.0",
    "@sparta.sales.utilities/common-utility": "^1.0.0",
    "@sparta.sales.utilities/rates-utility": "^1.0.0",
    "@sparta.global.helpers/select-helper": "^1.0.0",
    "@sparta.global.helpers/sparta-helper": "^1.0.0",
    "@sparta.global.helpers/squeezebox-helper": "^1.0.0",
    "@sparta.global.helpers/text-inputs-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-squeezebox-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-ui-layers-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-validation-framework-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-input-error-utility": "^1.0.0",
    "@sparta.global.vendors/jquery": "^3.2.1"
  },
  "stores": []
};

/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */

/**
 * @class paymentCalcAutoModuleJS
 * @extends {Module}
 */
class paymentCalcAutoModuleJS extends Module {
  /**
   * Creates an instance of paymentCalcAutoModuleJS.
   * @param {Object} options Module options
   * @memberof paymentCalcAutoModuleJS
   */
  constructor(options, context) {
    // eslint-disable-next-line no-param-reassign
    options.target = '.payment-calc-auto-module';
    super({
      ...options,
      context,
      config: _moduleConfig
    });
  }

  /**
   * Runs on module init
   * @returns {undefined}
   */
  init() {
    this.moduleEl = document.querySelector(this.settings.target);
    const self = this;
    const {
      $target
    } = this.settings;
    const isAuth = spaParams.siteName === 'secure-auto-loans';
    const $calcButton = $target.find('#calculateButton');
    const $updateButton = $target.find('#updateTotal');
    const $inputs = $('.payment-calc-auto-module').find('input');
    const $mainInputs = $inputs.parents().find('.main :input');
    const $totalMain = $target.find('#totalLoanAmountField');
    let $defaultInterestRate = $target.find('#interestRateField');
    const $breakDownInputs = $target.find('.break-down :input');
    const $dropDown = $target.find('#dropdown-arrow');
    const $breakDownLink = $target.find('#dropdown-heading');
    const userState = CommonAutoUtility.checkIfInternationalOrMilitaryAddress(this.Store.getUserSelectedState());
    const $term = $target.find('#term');
    if (this.isIphone()) {
      $('.interest-rate').hide();
      $('.interest-rate-iphone').removeClass('hide');
    } else {
      $('.interest-rate-iphone').hide();
      $('.interest-rate').show();
    }
    $target.spartaInputs();

    // dissallow decimals on currency fields
    this.settings.$target.on('keydown', 'input[data-sparta-input-format="currency"]', event => event.which !== 190);
    spartaSqueezeboxUtility.init();
    self.elementsToHideOnRatesError = ['#ctaStickyAutoModuleJS', '#paymentCalcAutoModuleJS', '#preferred-rewards-auto-module', '#h3-link-auto-module', '#calc-learning-auto-module', '#jumbotronBulletsAutoModuleJS', '.spa-legal-header', '#panel-legal'];

    // retain values in calculator across session
    CommonAutoUtility.retainInputValues($inputs);

    // append state code to disclosures
    $target.find('#stateCode').text(userState);

    // bind term field validation to the page
    const validations = {};
    validations[$term.attr('id')] = $term.data('validation-rules');
    spartaValidationFramework.fn.core.bindValidationRules(validations, true);
    RatesUtility.getAutoLoans(userState, isAuth).then(data => {
      if (self.isIphone()) {
        $defaultInterestRate = $('#interestRateIphoneField');
      }

      // populate interest Rate input with today's as low as apr
      $defaultInterestRate.val(data.ratesEffectivePercentage['Dealer New']);
      this._putPersistedLoanAmount($totalMain,
      // document.querySelector('#totalLoanAmountField')
      document.querySelector('[data-defaultloanamt]').getAttribute('data-defaultloanamt'));

      // populate APR if carried over
      // eslint-disable-next-line no-unused-expressions
      sessionStorage.getItem('userSelectedRatesEffectivePercentage') && $defaultInterestRate.val(sessionStorage.getItem('userSelectedRatesEffectivePercentage'));
      //
      // initial calculation
      self.updatePayments($inputs);
    }).fail(() => {
      self._onRatesErrorHandler();
      $calcButton.click();
    });

    // Adding validation for total loan field
    spartaValidationFramework.fn.core.removeValidationsByRule($totalMain, 'change');
    const minValue = userState === 'MN' ? 8000 : 7500;
    const errorMessage = spaParams.language === 'es' ? 'Indique una cantidad de pr&eacute;stamo entre $7,500 ($8,000 en MN) y &dollar;1,000,000.00' : 'Enter a loan amount between $7,500 ($8,000 in MN) and &dollar;1,000,000.00';
    const newRules = {
      // ID attribute of HTML element we will be applying validations to.
      totalLoanAmountField: {
        // When this event is received, trigger the following validations.
        change: {
          valueRange: {
            parameters: [minValue, 1000000],
            errorMessage
          }
        }
      }
    };
    spartaValidationFramework.fn.core.bindValidationRules(newRules, true);

    // open state selector on click of stateSelect
    $target.find('#stateSelect').on('click', () => {
      spartaUILayersUtility.openLayer($('#stateModalContent'));
      // eslint-disable-next-line no-undef
      spartaInputs.init('#stateModalContentSpartaUILayer');
    });

    // update payments on click of calculate button
    $calcButton.on('click', e => {
      e.preventDefault();
      if (!$dropDown.hasClass('active')) {
        $.each($breakDownInputs, () => {
          $(this).val('').blur();
        });
      }
      this.updatePayments($inputs);
      const $paymentAmount = $target.find('#amount');
      const amount = $paymentAmount.html();
      // this means there is an error on term field
      // focus on field
      if (amount === '&nbsp;') {
        // selects first ele with error class on it
        const errorField = $target.find('[class*="spa-error-form-input--"]')[0];
        if (errorField) {
          $(errorField).attr('tabindex', '0').focus();
        }
      } else {
        $('html, body').animate({
          scrollTop: $('.results').offset().top - 225
        }, 'slow');
      }
    });

    // trigger calc on enter of any input
    $inputs.keypress(e => {
      if (e.which === 13) {
        $calcButton.click();
      }
    });

    // if no value entered in 3 main inputs, upon tabbing out the value will default to 0
    $mainInputs.focusout(function () {
      if (this.value === '' || this.value === undefined) ;
      if (this.id === 'interestRateField' || this.id === 'interestRateIphoneField') {
        if (this.id === 'interestRateField') {
          // remove any period (.) % , and any leading zeros (example 0045 will be 45)
          const currentValue = this.value.replace(/^0+/, '').replace('%', '').replace(',', '').trim();
          if (currentValue > 100) {
            this.value = 100;
          } else if (currentValue === 0) {
            this.value = 0;
          }
        }
        // add % if it doesnt have it already
        if (!this.value.includes('%') && !isNaN(this.value)) {
          this.value = `${this.value}%`;
        }
        setTimeout(() => {
          // $defaultInterestRate.parent().removeClass('spa-input--empty');
        }, 50);
      }
    });

    // on the initial click, the interestRateIphoneField will go to 0.00
    $('#interestRateIphoneField').one('click', () => {
      if (self.isIphone()) {
        const value = 0;
        $('#interestRateIphoneField').val(value.toFixed(2));
      }
    });

    // convert interestRateField numbers into decimals %.
    /* example:
     * user input 1, the input field is 0.01
     * user input 12, the input field is 0.12
     * user input 125, the input field is 1.25
     */
    $('#interestRateIphoneField').on('input', () => {
      if (self.isIphone()) {
        self.changeNumberToCurrencyDecimal('#interestRateIphoneField');
      }
    });

    // if dropdown is active or not, on change of total Loan, close the accordion and reset fields to 0
    // the conditional used to contain this as a condition: $dropDown.hasClass('active')
    $totalMain.keyup(() => {
      if ($totalMain.val() !== '$ 0' || $totalMain.val().length <= 3) {
        self.disableBackground();
        self.deactivateBreakDown();
        $.each($breakDownInputs, input => {
          $breakDownInputs[input].value = '';
          $breakDownInputs.focusout();
        });
      }
      const totalVal = CommonUtility.removeCommasFromNumber($totalMain.val());
      if (totalVal < minValue || totalVal > 1000000) {
        $('#calculateButton').attr('disabled', true);
      } else {
        $('#calculateButton').removeAttr('disabled');
      }
      spartaValidationFramework.fn.core.validateAllFieldRules($totalMain);
    });

    // change background to gray when optional fields in dropdown are shown
    $breakDownLink.on('click', self.enableBackground);

    // update the total Loan amount upon clicking update total
    $updateButton.on('click', e => {
      e.preventDefault();
      const total = self.sumPurchase(self.mapInputs($inputs));
      self.mountTotal(total);
      const totalVal = CommonUtility.removeCommasFromNumber($totalMain.val());
      if (totalVal < minValue || totalVal > 1000000) {
        $('#calculateButton').attr('disabled', true);
      } else {
        $('#calculateButton').removeAttr('disabled');
      }
      spartaValidationFramework.fn.core.validateAllFieldRules($totalMain);
    });

    // schedule an appoinment link
    const scheduleURL = $('.schedule-appointment').attr('href');
    $('.schedule-appointment').attr('href', spaParams.siteParams.abpaEndpoint + scheduleURL);
  }

  // convert an input field numbers into decimals %.
  /* example:
   * user input 1, the input field is 0.01
   * user input 12, the input field is 0.12
   * user input 125, the input field is 1.25
   */
  changeNumberToCurrencyDecimal(elementName) {
    const element = this.moduleEl.querySelector(elementName);

    // remove any period (.) and any leading zeros (example 0045 will be 45)
    const currentValue = element.value.replace('.', '').replace('%', '').replace(/^0+/, '').trim();
    let newValue = parseFloat(currentValue / 100);
    if (newValue > 100) {
      newValue = 100;
      element.value = newValue.toFixed(2);
    } else {
      element.value = newValue.toFixed(2);
    }
  }

  // change color if breakdown fields are in view
  enableBackground() {
    $('#dropdown-heading').addClass('gray-background');
    $('.total').addClass('gray-background');
  }
  disableBackground() {
    $('#dropdown-heading').removeClass('gray-background');
    $('.total').removeClass('gray-background');
  }

  // if user starts typing in total loan amount after entering breakdown amounts, clear out and remove
  deactivateBreakDown() {
    $('#dropdown-arrow').removeClass('active');
    $('#dropdown-item').removeClass('active');
    const calculatePanel = document.getElementById('calculatorPanel');
    spartaSqueezeboxUtility.setActiveState(calculatePanel, false);
  }

  // calculate the sum purchase amount based on optional fields in dropdown
  sumPurchase(map) {
    let n = 0;
    const loan = map.add_amount;
    const price = map.add_car_price;
    // eslint-disable-next-line no-unused-vars
    $('#totalLoanAmountField');

    // remove the loan amount and add everything else if car price and loan amount are both present
    if ((loan !== '' || loan !== 0) && price !== 0) {
      // eslint-disable-next-line no-param-reassign
      map.add_amount = 0;
    }
    for (const k in map) {
      // eslint-disable-next-line no-prototype-builtins
      if (!map.hasOwnProperty(k)) {
        // eslint-disable-next-line no-continue
        continue;
      }
      // add or subtract each field based on name of each input field
      const type = k.substring(0, 4);
      if (type === 'add_') {
        // eslint-disable-next-line
        n += map[k];
      } else if (type === 'sub_') {
        // eslint-disable-next-line
        n -= map[k];
      }
    }
    if (n >= 0) {
      return n;
    }
    return 0;
  }

  // update the payment amount and append monthly payment to DOM
  mapInputs(inputs) {
    const map = {};

    // create a object to hold all values for each input and format number
    $.each(inputs, (e, val) => {
      map[val.name] = this.clampPurchase(val);
    });
    return map;
  }
  mountTotal(totalLoan) {
    // find loan amount field
    const $totalAmount = $('#totalLoanAmountField');

    // update total loan amount and blur so that totalAmount in session storage is updated
    $totalAmount.val(totalLoan).blur();
  }
  updatePayments(inputs) {
    // check the form for valid entries (only relevant on page load)

    // define dependencies
    const {
      $target
    } = this.settings;
    let map;
    let paymentAmount;
    let loanAmount;
    let totalLoan;
    let payments;

    // create map object
    map = this.mapInputs(inputs);
    let interestRate;
    // since iphone has a different interestRate input field, we want to calculate the loan using the correct field based on the correct field
    // if user is on the iphone, it will grab the "iphone-rate" name
    // if user is not on the iphone, it will grab the "rate" name
    // if there is the interestRate input field is blank or null, that input field will be "0.00" and calculateMonthlyPayment
    if (this.isIphone()) {
      interestRate = map['iphone-rate'];
      if (!interestRate) {
        const newValue = 0;
        $('#interestRateIphoneField').val(newValue.toFixed(2));
      }
    } else {
      interestRate = map.rate;
      if (!interestRate) {
        const newValue = 0;
        $('#interestRateField').val(newValue.toFixed(2));
      }
    }

    // get the total amount of loan needed for purchase
    totalLoan = this.sumPurchase(map);

    // calculate payments for each month, rounded up
    payments = CommonUtility.calculateMonthlyPayment(totalLoan, interestRate, map.term);

    // find element to append monthly payment and loan amount to
    paymentAmount = $target.find('#amount');
    loanAmount = $target.find('#loanAmount');
    const $term = $target.find('#term');
    spartaValidationFramework.fn.core.validateAllFieldRules($term); // trigger data validation
    const requiredFieldsValid = spartaValidationFramework.fn.core.validateRequiredFields($target.find('[required]:visible')); // trigger required field validation
    const valid = requiredFieldsValid && $target.find('.spa-error-form-input--validation').length === 0;
    // add number to paymentAmount element
    const $dollar = $target.find('.dollar');
    if (valid) {
      $dollar.show();
      paymentAmount.text(payments);
    } else {
      $dollar.hide();
      paymentAmount.html('&nbsp;');
    }
    // remove the loan amount if the payments are 0
    if (payments === 0) {
      $('.amount-text').hide();
    } else {
      $('.amount-text').show();
    }
    loanAmount.text(this._numberWithCommas(totalLoan));
    this.mountTotal(this._numberWithCommas(totalLoan));
  }

  // format numbers from input field based on id of input field
  clampPurchase(input) {
    const el = $(input);
    const min = el.attr('min');
    const max = el.attr('max');
    let n;

    // format number differently depending on type of input it is
    if (el.attr('id') === 'term' || el.attr('id') === 'interestRateField' || el.attr('id') === 'interestRateIphoneField') {
      n = CommonUtility.removeCommasFromNumber(el.val());
    } else if (Number.isNaN(parseInt(el.val().slice(0, 1)))) {
      n = CommonUtility.removeCommasFromNumber(el.val().substr(2));
    } else {
      n = CommonUtility.removeCommasFromNumber(el.val());
    }
    if (Number.isNaN(n)) {
      return 0;
    }
    if (min) {
      n = Math.max(parseFloat(min), n);
    }
    if (max) {
      n = Math.min(parseFloat(max), n);
    }
    return Math.abs(n);
  }
  isIphone() {
    return /iPhone/.test(navigator.userAgent) && !window.MSStream;
  }
  _onRatesErrorHandler() {
    $('#pageErrorAutoModule').show();
    $(this.elementsToHideOnRatesError.join(',')).addClass('hide');
    if (spaParams.siteName === 'auto-loans') {
      $('#err_return_to_your_accounts').addClass('hide');
    }
    $('#pageErrorAutoModule').css('padding-bottom', '125px');
  }
  _putPersistedLoanAmount($input, loanAmount = 50000) {
    try {
      const persistedAmount = sessionStorage.getItem('totalLoanAmountField');
      if (persistedAmount) {
        loanAmount = persistedAmount;
      }
    } catch (e) {
      console.log(e);
    }
    $input.val(loanAmount).focus();
  }
  _numberWithCommas(amount) {
    // format number to insert back into DOM
    return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
}
registerModuleClass({
  moduleClass: paymentCalcAutoModuleJS,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { paymentCalcAutoModuleJS as default, moduleConfig };
